import Box, { BoxProps } from '@mui/material/Box';

export const Blockquote = (props: BoxProps) => (
    <Box
        component="blockquote"
        {...props}
        sx={[
            (theme) => ({
                fontSize: theme.typography.body1.fontSize,
                borderLeft: '2px solid',
                borderLeftColor: 'primary.main',
                margin: 0,
                py: 2,
                px: 3,
            }),
            ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ]}
    />
);
